import { useAuthContext } from '@porterin/feature/src/containers/login/view-model/contexts/auth-context/AuthContextV1';
import { useCitySelectedContext } from '@porterin/feature/src/contexts/city-context/CityContext';
import { convertAuthContext } from '@porterin/feature/src/shared/core/helpers/AuthBinding';
import {
  serviceCategoryToGAString,
  serviceCategoryToString,
} from '@porterin/feature/src/shared/core/helpers/CommonVehicleHelper';
import FareEstimateFormCmp from '@porterin/lead-flow/src/components/FareEstimateFormCmp';
import FareEstimateMobileFormCmp from '@porterin/lead-flow/src/components/FareEstimateMobileFormCmp';
import React from 'react';

import styles from '../styles/FareEstimateForms.module.scss';

import ChangeCategoryCmp from './ChangeCategoryCmp';

interface SpotFareEstimateWrapperCmpProps {
  onChangeCategory: () => void;
  category_name: string;
  change_label: string;
  is_mobile?: boolean;
  service_category: number;
}

function SpotFareEstimateWrapperCmp({
  onChangeCategory,
  category_name,
  change_label,
  is_mobile = false,
  service_category,
}: Readonly<SpotFareEstimateWrapperCmpProps>): React.ReactElement {
  const citySelectedContext = useCitySelectedContext();
  const authBinding = convertAuthContext(useAuthContext());

  const leadFlowCityContext = {
    citySelected: citySelectedContext.city_selected,
    selectedCityLabel: citySelectedContext.selected_city_label,
    setCitySelected: citySelectedContext.set_city_selected,
    category: citySelectedContext.category,
    queryParams: citySelectedContext.query_params,
  };

  const category = serviceCategoryToString(service_category);

  return (
    <div className={styles['component-wrapper']}>
      <ChangeCategoryCmp
        change_label={change_label}
        className={styles['change-category']}
        onChangeCategory={onChangeCategory}
        currentCategory={serviceCategoryToGAString(service_category)}
        category_name={category_name}
      />
      {is_mobile ? (
        <FareEstimateMobileFormCmp
          category={category}
          city_context={leadFlowCityContext}
          auth_data={authBinding}
          on_lead_success_handler={() => {}}
        />
      ) : (
        <FareEstimateFormCmp
          category={category}
          city_context={leadFlowCityContext}
          auth_data={authBinding}
          on_lead_success_handler={() => {}}
        />
      )}
    </div>
  );
}

export default SpotFareEstimateWrapperCmp;
